import { toast } from "react-toastify";
import { getApiUrl } from "./main";
import React from 'react';

const CustomErrorToast = ({ title, message }) => (
  <div style={{ color: "#f43f5e" }}>
    <h4 style={{ margin: 0, fontWeight: "bold", fontSize: "1rem" }}>{title}</h4>
    <p style={{ margin: "5px 0 0", fontSize: "1rem" }}>{message}</p>
  </div>
);

const getOauthParams = () => {
  // Get OAuth-related query parameters from the current page's URL
  const urlParams = new URLSearchParams(window.location.search);
  const oauthParams = [
    "client_id",
    "redirect_uri",
    "response_type",
    "scope",
    "state",
    "code_challenge",
    "code_challenge_method",
  ];

  // Collect only the OAuth-related parameters
  const params = new URLSearchParams();
  oauthParams.forEach((param) => {
    if (urlParams.has(param)) {
      params.set(param, urlParams.get(param));
    }
  });

  return params;
};

export const login = async (
  email,
  password,
  oauthParams = getOauthParams()
) => {
  try {
    const response = await fetch(
      getApiUrl(`/login?${oauthParams.toString()}`),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      }
    );

    if (response.ok) {
      console.log("Login successful");
      window.location.href = response.url;
    }
    else {
      if (response.status === 401) {

        toast.error(<CustomErrorToast title="Login failed" message="Invalid email or password." />);
        console.error("Login failed 1");
        return;
      }

      const errorMessage = await response.text();
      const errorJson = JSON.parse(errorMessage);
      toast.error(`Login failed. - ${errorJson.error}`);
      console.error("Login failed 2");
    }
  } catch {
    toast.error("Login Failed");
    console.error("Login failed 3");
  }
};

export const register = async (formData) => {
  const response = await fetch(getApiUrl("/register"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    throw new Error("Registration failed");
  }
};

export const fetchTokens = async (
  code,
  clientId,
  codeVerifier,
  redirectUri
) => {
  const params = new URLSearchParams();
  params.append("grant_type", "authorization_code");
  params.append("code", code);
  params.append("client_id", clientId);
  params.append("code_verifier", codeVerifier);
  params.append("redirect_uri", redirectUri);

  return await fetch(getApiUrl("/oauth/token"), {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: params.toString(),
  });
};
